import { render } from "./IconEdit.vue?vue&type=template&id=76ca82dd"
import script from "./IconEdit.vue?vue&type=script&lang=js"
export * from "./IconEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/16/IconEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76ca82dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76ca82dd', __exports__)) {
    api.reload('76ca82dd', __exports__)
  }
  
  module.hot.accept("./IconEdit.vue?vue&type=template&id=76ca82dd", () => {
    api.rerender('76ca82dd', render)
  })

}


export default __exports__